import {useState,useEffect} from "react"
import IVenue from '../interfaces/IVenue';
import { useSelector } from "react-redux";
import { IReduxAppState } from "../reducers";
import { useAPIV2 } from '../yoello-lib/modules/API2/useAPIv2';
import APIExtensions from '../yoello-lib/modules/API2/APIDefs';
import { HTTPMethods } from "../yoello-lib/modules/API/API";
export interface IProcessingPlan {
  id: string;
  name_public:string;
  order_processing_charge:number;
  order_processing_charge_percentage: number;
}
export function useSubscription() {
    const [OnboardingSource, setOnboardingSource] = useState<string|null>(null)
    const [FeesPlan, setFeesPlan] = useState<IProcessingPlan|null>(null)
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const { callAPI , isLoading} = useAPIV2<any>(APIExtensions.feePlans, {
      canAPIGetCacheValue: true,
  });
    const { apiData: venuesData } = useAPIV2<IVenue>(
        APIExtensions.venues,
        {
          query: selectedVenueId,
          canAPIGetCacheValue: true,
          selectorKeyParams: { venue_id: selectedVenueId },
          dispatcherParams: [selectedVenueId],
    
        }
      );
    useEffect(()=>{
        if(venuesData?.onboarding_source){
            setOnboardingSource(venuesData.onboarding_source)
        }
    // eslint-disable-next-line    
    },[venuesData?.onboarding_source])  
    useEffect(()=>{
        if(venuesData?.processing_fees_plans_id){
          const fetchData = async () => {
            const response = await callAPI(HTTPMethods.GET, {
                query:venuesData.processing_fees_plans_id
            });
            if (response.isSuccessful) {
              const {data} = response;
              setFeesPlan(data);
            }
        };
        fetchData();
       
        }
    // eslint-disable-next-line    
    },[venuesData?.processing_fees_plans_id])  
    return {OnboardingSource,FeesPlan,isLoading,selectedVenueId}
}